import http from '@/api/http'

export default {
  /**
   * デバイストークンをサーバに POST
   */
  postDeviceToken(params): Promise<any> {
    return new Promise((resolve, reject) => {
      http
        .post('/regist_device_token/', params)
        .then(res => {
          resolve(res.data)
        })
        .catch(reject)
    })
  }
}
